var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftShort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5627 9.35137L9.44307 0.568331C9.36539 0.501367 9.26628 0.463867 9.16182 0.463867H6.79128C6.59307 0.463867 6.502 0.710296 6.652 0.838867L16.0324 8.98172H0.357352C0.239495 8.98172 0.143066 9.07815 0.143066 9.19601V10.8032C0.143066 10.921 0.239495 11.0174 0.357352 11.0174H16.0297L6.64932 19.1603C6.49932 19.2915 6.59039 19.5353 6.7886 19.5353H9.2395C9.29039 19.5353 9.34128 19.5165 9.37878 19.4817L19.5627 10.6478C19.6554 10.5672 19.7298 10.4676 19.7807 10.3557C19.8317 10.2439 19.8581 10.1225 19.8581 9.99958C19.8581 9.8767 19.8317 9.75524 19.7807 9.64342C19.7298 9.53159 19.6554 9.432 19.5627 9.35137Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftShort);
export default __webpack_public_path__ + "static/media/arrow-left-short.e7df2ef2e34665cf695c8181dba543d4.svg";
export { ForwardRef as ReactComponent };